"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagTJ = function FlagTJ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v82.39H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-11.34,37.41a13.08,13.08,0,0,0,5.57-5.68C-.51,35.17,4,34,6.34,32.9a14.17,14.17,0,0,0,5.44-4.61,14.25,14.25,0,0,0,5.44,4.61c2.35,1.1,6.85,2.26,12.12-1.17a13,13,0,0,0,5.57,5.68,12.27,12.27,0,0,0,5.58,1.28,19.26,19.26,0,0,0,6.73-1.35l-1.17-3.11c-3.81,1.43-7,1.51-9.62.23a10.32,10.32,0,0,1-4.79-5.77l-.71-2.45L29,27.87c-3.46,2.88-7,3.58-10.35,2s-5.19-4.76-5.19-5.73V9.84a4.58,4.58,0,0,1,4.15-2.69,4.49,4.49,0,0,1,1.86.41l2.06.93L21.2,6.26a9.5,9.5,0,0,0-18.83,0L2.05,8.49l2.06-.93a4.52,4.52,0,0,1,6,2.28V24.16c0,1-1.82,4.16-5.19,5.73s-6.89.86-10.34-2l-1.95-1.61-.71,2.42a10.38,10.38,0,0,1-4.8,5.78c-2.57,1.28-5.81,1.2-9.62-.23l-1.17,3.11a19.26,19.26,0,0,0,6.73,1.35,12.32,12.32,0,0,0,5.59-1.28ZM6,4.66a5.83,5.83,0,0,0-.59,0,7,7,0,0,1,12.8,0,7.08,7.08,0,0,0-6.4,3A7.06,7.06,0,0,0,6,4.66Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17,48l1.05,3.15c7.06-2.36,17.15-3.71,27.69-3.71s20.63,1.35,27.69,3.71L40.52,48c-7.38-2.46-17.86-3.88-28.74-3.88S-9.58,45.5-17,48Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.78,40.76a5.47,5.47,0,0,0,4.29-2.4,6.62,6.62,0,0,0-2.64-.81s0-.07,0-.1a4,4,0,0,0-1.66-3.32,4,4,0,0,0-1.66,3.32s0,.07,0,.1a6.52,6.52,0,0,0-2.64.81,5.45,5.45,0,0,0,4.28,2.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3.45,42.33A5.49,5.49,0,0,0,.27,39.11a6.84,6.84,0,0,0-2.75-.25s0-.07,0-.11a4,4,0,0,0-2.29-2.92,4,4,0,0,0-1,3.58l0,.11a6.54,6.54,0,0,0-2.42,1.31,5.47,5.47,0,0,0,4.68,1.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.34,35.83a4,4,0,0,0-2.29,2.92.41.41,0,0,1,0,.11,6.77,6.77,0,0,0-2.74.25A5.45,5.45,0,0,0,27,42.33a5.48,5.48,0,0,0,4.68-1.5,6.52,6.52,0,0,0-2.43-1.31s0-.07,0-.11a4,4,0,0,0-1-3.58Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.34-25.3l-1.12,3.35-3.53,0a.48.48,0,0,0-.28.86L9.25-19,8.18-15.59a.48.48,0,0,0,.73.53l2.88-2.06,2.88,2.06a.48.48,0,0,0,.73-.53L14.33-19l2.84-2.1a.48.48,0,0,0-.28-.86l-3.53,0L12.24-25.3a.48.48,0,0,0-.9,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-8.89-19.77-10-16.41l-3.53,0a.48.48,0,0,0-.28.86l2.84,2.1L-12-10.06a.47.47,0,0,0,.73.53l2.87-2.06,2.88,2.06a.48.48,0,0,0,.73-.53L-5.9-13.43l2.84-2.1a.48.48,0,0,0-.28-.86l-3.53,0L-8-19.77a.48.48,0,0,0-.9,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-23.76-4.83l-1.12,3.35-3.53,0a.48.48,0,0,0-.28.86l2.84,2.1-1.06,3.37a.48.48,0,0,0,.73.53l2.87-2.06,2.88,2.06a.48.48,0,0,0,.73-.53l-1.07-3.37,2.85-2.1a.48.48,0,0,0-.28-.86l-3.53,0-1.13-3.35a.47.47,0,0,0-.9,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-29.22,15.36l-1.12,3.35-3.53,0a.48.48,0,0,0-.28.86l2.84,2.1-1.07,3.37a.48.48,0,0,0,.73.53l2.88-2.05,2.87,2.05a.48.48,0,0,0,.74-.53l-1.07-3.37,2.84-2.1a.48.48,0,0,0-.28-.86l-3.53,0-1.12-3.35a.48.48,0,0,0-.9,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.49-19.77l1.12,3.36,3.53,0a.48.48,0,0,1,.28.86l-2.84,2.1,1.06,3.37a.47.47,0,0,1-.73.53L32-11.59,29.16-9.53a.48.48,0,0,1-.73-.53l1.07-3.37-2.84-2.1a.48.48,0,0,1,.27-.86l3.54,0,1.12-3.36a.48.48,0,0,1,.9,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.36-4.83l1.12,3.35,3.53,0a.48.48,0,0,1,.28.86l-2.85,2.1,1.07,3.37a.48.48,0,0,1-.73.53L46.91,3.35,44,5.41a.48.48,0,0,1-.73-.53l1.07-3.37L41.52-.59a.48.48,0,0,1,.28-.86l3.54,0,1.12-3.35a.47.47,0,0,1,.9,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.82,15.36l1.12,3.35,3.53,0a.48.48,0,0,1,.28.86l-2.84,2.1L56,25.07a.48.48,0,0,1-.74.53l-2.87-2.05L49.49,25.6a.47.47,0,0,1-.73-.53l1.07-3.37L47,19.6a.48.48,0,0,1,.29-.86l3.53,0,1.12-3.35a.48.48,0,0,1,.9,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagTJ;
exports["default"] = _default;